<template>
    <stores-map-section
        class="stores-map-section-module"
    />
</template>

<script>
    import StoresMapSection from '../../../organisms/StoresMapSection/StoresMapSection';

    export default {
        name: 'stores-map-section-module',

        components: { StoresMapSection },

        props: {
            attributes: {
                type: Object,
                default: () => ({}),
            },
        },
    };
</script>
